export default __webpack_public_path__ + "static/media/dep1_3.4c4299ad.png";